import { useMemo } from "react";

const useListOfPolicy = ({
  password,
  confirmedPassword,
}: {
  password: string;
  confirmedPassword: string;
}) => {
  const {
    isUpperCase,
    isLowerCase,
    isSpecial,
    isMinimum,
    isNumeric,
    isPasswordsMatch,
  } = useMemo(
    () => ({
      isUpperCase: /^(?=.*?[A-Z])/.test(password),
      isLowerCase: /^(?=.*?[a-z])/.test(password),
      isSpecial: /^(?=.*?[#?!@$%^&*-])/.test(password),
      isMinimum: /^.{8,}/.test(password),
      isNumeric: /^(?=.*?[0-9])/.test(password),
      isPasswordsMatch: !!(
        password &&
        confirmedPassword &&
        password === confirmedPassword
      ),
    }),
    [confirmedPassword, password]
  );

  const listOfPolicy = useMemo(
    () => [
      {
        done: isMinimum,
        text: "Minimum 8 characters",
      },
      {
        done: isLowerCase,
        text: "One lowercase character",
      },
      {
        done: isUpperCase,
        text: "One uppercase character",
      },

      {
        done: isSpecial,
        text: "One special character",
      },

      {
        done: isNumeric,
        text: "One number",
      },
      {
        done: isPasswordsMatch,
        text: "Passwords do match",
      },
    ],
    [
      isLowerCase,
      isUpperCase,
      isSpecial,
      isMinimum,
      isNumeric,
      isPasswordsMatch,
    ]
  );

  return {
    listOfPolicy,
    isLowerCase,
    isUpperCase,
    isMinimum,
    isNumeric,
    isSpecial,
    isPasswordsMatch,
  };
};
export default useListOfPolicy;
